import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickStatsCard = ({ icon, title, value, subtitle, trend, trendDirection }) => {
  const getTrendColor = (direction) => {
    switch (direction) {
      case 'up':
        return 'text-success';
      case 'down':
        return 'text-error';
      default:
        return 'text-text-muted';
    }
  };

  const getTrendIcon = (direction) => {
    switch (direction) {
      case 'up':
        return 'TrendingUp';
      case 'down':
        return 'TrendingDown';
      default:
        return 'Minus';
    }
  };

  return (
    <div className="bg-surface border border-border rounded-lg p-4 lg:p-6 shadow-elevation-1">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
          <Icon name={icon} size={20} className="text-primary" />
        </div>
        {trend && (
          <div className={`flex items-center space-x-1 ${getTrendColor(trendDirection)}`}>
            <Icon name={getTrendIcon(trendDirection)} size={14} />
            <span className="text-xs font-medium">{trend}</span>
          </div>
        )}
      </div>
      
      <div>
        <h3 className="text-2xl lg:text-3xl font-bold text-text-primary mb-1">
          {value}
        </h3>
        <p className="text-sm font-medium text-text-secondary mb-1">
          {title}
        </p>
        {subtitle && (
          <p className="text-xs text-text-muted">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
};

export default QuickStatsCard;